import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'

import Layout from './components/Layout/Layout'
import LoginPage from './pages/Auth/LoginPage'
import DashboardPage from './pages/Dashboard/DashboardPage'
import SelfEvaluationPage from './pages/Evaluation/SelfEvaluationPage'
import GoalSettingPage from './pages/Evaluation/GoalSettingPage'
import GoalApprovalPage from './pages/Evaluation/GoalApprovalPage'
import ManagerEvaluationListPage from './pages/Evaluation/ManagerEvaluationListPage'
import ManagerEvaluationFormPage from './pages/Evaluation/ManagerEvaluationFormPage'
import ManagerEvaluationPage from './pages/Evaluation/ManagerEvaluationPage'
import DeptEvaluationPage from './pages/Evaluation/DeptEvaluationPage'
import DeptHeadEvaluationListPage from './pages/Evaluation/DeptHeadEvaluationListPage'
import DeptHeadEvaluationFormPage from './pages/Evaluation/DeptHeadEvaluationFormPage'
import NotificationPage from './pages/Notification/NotificationPage'
import ReportPage from './pages/Report/ReportPage'
import UserManagementPage from './pages/Admin/UserManagementPage'
import DepartmentManagementPage from './pages/Admin/DepartmentManagementPage'
import RankCostManagementPage from './pages/Admin/RankCostManagementPage';
import PositionManagementPage from './pages/Admin/PositionManagementPage';
import JobTitleManagementPage from './pages/Admin/JobTitleManagementPage';
import EvaluationItemManagementPage from './pages/Admin/EvaluationItemManagementPage';
import EvaluationRouteManagementPage from './pages/Admin/EvaluationRouteManagementPage';
import EvaluationPeriodManagementPage from './pages/Admin/EvaluationPeriodManagementPage';
import RValueManagementPage from './pages/Admin/RValueManagementPage';
import HRAllEvaluationsPage from './pages/HR/HRAllEvaluationsPage';
import HREvaluationDetailPage from './pages/HR/HREvaluationDetailPage';
import SkillMasterManagementPage from './pages/Skills/SkillMasterManagementPage';
import MySkillsPage from './pages/Skills/MySkillsPage';
import SkillApprovalPage from './pages/Skills/SkillApprovalPage';
import {
  SalesCasesPage,
  SalesCaseDetailPage,
  SalesCaseCreatePage,
  SalesCaseEditPage,
  SalesKpiDashboardPage,
  AccountMasterPage,
  SalesSnapshotsPage,
} from './pages/Sales';
import { FunctionalPermissionsPage, AuditLogsPage } from './pages/Admin';
import SettingsPage from './pages/Settings/SettingsPage'
import ProfilePage from './pages/Profile/ProfilePage'
import { useAuth } from './contexts/AuthContext'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import LoadingSpinner from './components/Common/LoadingSpinner'

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height="100vh"
      >
        <LoadingSpinner />
      </Box>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Routes>
        {/* ダッシュボード */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />

        {/* 評価システム */}
        <Route path="/evaluation/goals" element={<GoalSettingPage />} />
        <Route path="/evaluation/goals/approval" element={<GoalApprovalPage />} />
        <Route path="/evaluation/self" element={<SelfEvaluationPage />} />
        <Route
          path="/manager-evaluation/:periodId"
          element={
            <ProtectedRoute>
              <ManagerEvaluationListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manager-evaluation/:employeeId/:periodId"
          element={
            <ProtectedRoute>
              <ManagerEvaluationFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/evaluation/manager"
          element={
            <ProtectedRoute>
              <ManagerEvaluationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/evaluation/department"
          element={
            <ProtectedRoute>
              <DeptEvaluationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dept-head-evaluation/:periodId"
          element={
            <ProtectedRoute>
              <DeptHeadEvaluationListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dept-head-evaluation/:employeeId/:periodId"
          element={
            <ProtectedRoute>
              <DeptHeadEvaluationFormPage />
            </ProtectedRoute>
          }
        />

        {/* 通知 */}
        <Route path="/notifications" element={<NotificationPage />} />

        {/* レポート */}
        <Route path="/reports" element={<ReportPage />} />

        {/* 管理機能 */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute roles={['hr', 'system_supervisor']}>
              <UserManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/departments"
          element={
            <ProtectedRoute roles={['hr']}>
              <DepartmentManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/rank-cost"
          element={
            <ProtectedRoute roles={['hr']}>
              <RankCostManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/positions"
          element={
            <ProtectedRoute roles={['hr']}>
              <PositionManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/job-titles"
          element={
            <ProtectedRoute roles={['hr']}>
              <JobTitleManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/evaluation-items"
          element={
            <ProtectedRoute roles={['hr']}>
              <EvaluationItemManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/evaluation-routes"
          element={
            <ProtectedRoute roles={['hr']}>
              <EvaluationRouteManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/evaluation-periods"
          element={
            <ProtectedRoute roles={['hr']}>
              <EvaluationPeriodManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/r-value"
          element={
            <ProtectedRoute roles={['hr']}>
              <RValueManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/skills/master"
          element={
            <ProtectedRoute requireSkillPermission="skill_master_editor">
              <SkillMasterManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/permissions"
          element={
            <ProtectedRoute roles={['skill_supervisor', 'sales_supervisor']}>
              <FunctionalPermissionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/audit-logs"
          element={
            <ProtectedRoute roles={['system_supervisor']}>
              <AuditLogsPage />
            </ProtectedRoute>
          }
        />

        {/* HR評価管理 */}
        <Route
          path="/hr/evaluations"
          element={
            <ProtectedRoute roles={['hr']}>
              <HRAllEvaluationsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hr/evaluations/:employeeId/:periodId"
          element={
            <ProtectedRoute roles={['hr']}>
              <HREvaluationDetailPage />
            </ProtectedRoute>
          }
        />

        {/* スキル管理 */}
        <Route
          path="/skills/my-skills"
          element={
            <ProtectedRoute requireTechnicalDept={true}>
              <MySkillsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/skills/approval"
          element={
            <ProtectedRoute requireTechnicalDept={true}>
              <SkillApprovalPage />
            </ProtectedRoute>
          }
        />

        {/* 営業数字管理 */}
        <Route
          path="/sales/cases"
          element={
            <ProtectedRoute requireSalesPermission="view_cases">
              <SalesCasesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/cases/new"
          element={
            <ProtectedRoute requireSalesPermission="manage_cases">
              <SalesCaseCreatePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/cases/:caseId"
          element={
            <ProtectedRoute requireSalesPermission="view_cases">
              <SalesCaseDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/cases/:caseId/edit"
          element={
            <ProtectedRoute requireSalesPermission="manage_cases">
              <SalesCaseEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/kpi"
          element={
            <ProtectedRoute requireSalesPermission="view_kpi">
              <SalesKpiDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/accounts"
          element={
            <ProtectedRoute requireSalesPermission="manage_accounts">
              <AccountMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/snapshots"
          element={
            <ProtectedRoute requireSalesPermission="view_kpi">
              <SalesSnapshotsPage />
            </ProtectedRoute>
          }
        />

        {/* 個人設定 */}
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<SettingsPage />} />

        {/* 404 */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
